import * as planck from 'planck-js'
import type { IEntityWithBody } from '../../../entities/entitiesUtilsPhysics'
import type { IXY } from '../../../lib/distanceUtil'
import { golfPhysicsDebug } from './golfPhysicsDebug-sidecar'
import type { IBodyDef, IFixDef, IGolfPhysicsDef } from './golfPhysicsDefs'

// See: https://www.emanueleferonato.com/2019/10/12/use-box2d-physics-in-your-phaser-3-projects-with-planck-js-javascript-physics-engine/
export const worldScale = 32
export const timeStep = 1 / 60

const enableDebugLog = true
export function physicsLog(...x: any[]) {
  if (enableDebugLog) {
    console.log('physics', ...x)
  }
}

let _world: planck.World | null = null
export function get(): planck.World {
  if (!_world) {
    let gravity = planck.Vec2(0, 0)
    _world = planck.World(gravity)
  }
  return _world
}

export function create() {
  get()
}

export function updateAll() {
  let world = get()
  world.step(timeStep)
  world.clearForces()
}

export function createBody() {
  let world = get()
  let body = world.createBody()
  body.setDynamic()
  return body
}

export function createBodyCircle(
  x: number,
  y: number,
  radius: number,
  def: IGolfPhysicsDef,
  // options: {
  //   fixDef?: IFixDef
  //   bodyDef: IBodyDef
  //   dynamic: boolean
  //   collisionType: CollisionEntityType
  // },
) {
  let world = get()
  let body = world.createBody(def.body)

  // if (options.dynamic) {
  //   body.setBullet(true)
  //   body.setDynamic()
  // }

  body.setBullet(true)
  body.setDynamic()

  // body.setUserData(options.collisionType)

  // a body can have one or more fixtures. This is how we create a box fixture inside a body
  body.createFixture(planck.Circle(radius / worldScale), def.fix)

  // now we place the body in the world
  moveBodyTo(body, x, y)

  // time to set mass information
  // body.setMassData({
  //   mass: 1,
  //   center: planck.Vec2(),

  //   // I have to say I do not know the meaning of this "I", but if you set it to zero, bodies won't rotate
  //   I: 1,
  // })

  golfPhysicsDebug.addBody(body)

  return body
}

export function createBodyBox(
  x: number,
  y: number,
  width: number,
  height: number,
  options: {
    fixDef?: IFixDef
    bodyDef: IBodyDef
    dynamic?: boolean
  },
) {
  let world = get()
  let body = world.createBody(options.bodyDef)

  if (options.dynamic) {
    body.setBullet(true)
    body.setDynamic()
  }

  // a body can have one or more fixtures. This is how we create a box fixture inside a body
  body.createFixture(
    planck.Box(width / 2 / worldScale, height / 2 / worldScale),
    options.fixDef,
  )

  // time to set mass information
  body.setMassData({
    mass: 1,
    center: planck.Vec2(),

    // I have to say I do not know the meaning of this "I", but if you set it to zero, bodies won't rotate
    I: 1,
  })

  // now we place the body in the world
  console.log('move body to', x, y)
  moveBodyTo(body, x, y)

  golfPhysicsDebug.addBody(body)

  return body
}

export function moveBodyTo(body: planck.Body, x: number, y: number) {
  body.setPosition(planck.Vec2(x / worldScale, y / worldScale))
}

export function syncBody(obj: IEntityWithBody & IXY) {
  obj.body.setPosition(planck.Vec2(obj.x / worldScale, obj.y / worldScale))
}

export function destroyBody(body: planck.Body) {
  let world = get()
  world.destroyBody(body)
  golfPhysicsDebug.removeBody(body)
}

export function syncImage(
  image: {
    x: number
    y: number
    rotation: number
    scale: number
    displayWidth: number
    displayHeight: number
  },
  body: planck.Body,
) {
  let p = body.getPosition()
  image.x = p.x * worldScale
  image.y = p.y * worldScale

  // if (image.scale !== 1) {
  //   console.log('scale !== 1', image)
  //   //image.x -= image.displayWidth * 0.5
  //   //image.y -= image.displayHeight * 0.5
  // }

  // get body angle, in radians
  let bodyAngle = body.getAngle()
  image.rotation = bodyAngle
  //  // get body user data, the graphics object
  //  let userData = b.getUserData();
}
